Object.defineProperty(exports, "__esModule", {
    value: true
});
var _async_to_generator = require("@swc/helpers/_/_async_to_generator");
var _class_call_check = require("@swc/helpers/_/_class_call_check");
var _create_class = require("@swc/helpers/_/_create_class");
var _object_spread = require("@swc/helpers/_/_object_spread");
var _object_spread_props = require("@swc/helpers/_/_object_spread_props");
var _to_consumable_array = require("@swc/helpers/_/_to_consumable_array");
var require_logger = require('./utils/logger.cjs');
var require_constant = require('./constant.cjs');
var require_share = require('./utils/share.cjs');
var require_env = require('./utils/env.cjs');
var require_plugin = require('./utils/plugin.cjs');
var require_load = require('./utils/load.cjs');
require('./utils/index.cjs');
var require_index$1 = require('./module/index.cjs');
var require_syncHook = require('./utils/hooks/syncHook.cjs');
var require_asyncHook = require('./utils/hooks/asyncHook.cjs');
var require_syncWaterfallHook = require('./utils/hooks/syncWaterfallHook.cjs');
var require_asyncWaterfallHooks = require('./utils/hooks/asyncWaterfallHooks.cjs');
var require_pluginSystem = require('./utils/hooks/pluginSystem.cjs');
require('./utils/hooks/index.cjs');
var require_index$3 = require('./plugins/snapshot/index.cjs');
var require_generate_preload_assets = require('./plugins/generate-preload-assets.cjs');
var require_SnapshotHandler = require('./plugins/snapshot/SnapshotHandler.cjs');
var require_index$4 = require('./shared/index.cjs');
var require_index$5 = require('./remote/index.cjs');
var _module_federation_sdk = require("@module-federation/sdk");
var _module_federation_error_codes = require("@module-federation/error-codes");
//#region src/core.ts
var USE_SNAPSHOT = typeof FEDERATION_OPTIMIZE_NO_SNAPSHOT_PLUGIN === "boolean" ? !FEDERATION_OPTIMIZE_NO_SNAPSHOT_PLUGIN : true;
var ModuleFederation = /*#__PURE__*/ function() {
    "use strict";
    function ModuleFederation(userOptions) {
        _class_call_check._(this, ModuleFederation);
        this.hooks = new require_pluginSystem.PluginSystem({
            beforeInit: new require_syncWaterfallHook.SyncWaterfallHook("beforeInit"),
            init: new require_syncHook.SyncHook(),
            beforeInitContainer: new require_asyncWaterfallHooks.AsyncWaterfallHook("beforeInitContainer"),
            initContainer: new require_asyncWaterfallHooks.AsyncWaterfallHook("initContainer")
        });
        this.version = "2.3.3";
        this.moduleCache = /* @__PURE__ */ new Map();
        this.loaderHook = new require_pluginSystem.PluginSystem({
            getModuleInfo: new require_syncHook.SyncHook(),
            createScript: new require_syncHook.SyncHook(),
            createLink: new require_syncHook.SyncHook(),
            fetch: new require_asyncHook.AsyncHook(),
            loadEntryError: new require_asyncHook.AsyncHook(),
            getModuleFactory: new require_asyncHook.AsyncHook()
        });
        this.bridgeHook = new require_pluginSystem.PluginSystem({
            beforeBridgeRender: new require_syncHook.SyncHook(),
            afterBridgeRender: new require_syncHook.SyncHook(),
            beforeBridgeDestroy: new require_syncHook.SyncHook(),
            afterBridgeDestroy: new require_syncHook.SyncHook()
        });
        var plugins = USE_SNAPSHOT ? [
            require_index$3.snapshotPlugin(),
            require_generate_preload_assets.generatePreloadAssetsPlugin()
        ] : [];
        var defaultOptions = {
            id: require_env.getBuilderId(),
            name: userOptions.name,
            plugins,
            remotes: [],
            shared: {},
            inBrowser: _module_federation_sdk.isBrowserEnvValue
        };
        this.name = userOptions.name;
        this.options = defaultOptions;
        this.snapshotHandler = new require_SnapshotHandler.SnapshotHandler(this);
        this.sharedHandler = new require_index$4.SharedHandler(this);
        this.remoteHandler = new require_index$5.RemoteHandler(this);
        this.shareScopeMap = this.sharedHandler.shareScopeMap;
        this.registerPlugins(_to_consumable_array._(defaultOptions.plugins).concat(_to_consumable_array._(userOptions.plugins || [])));
        this.options = this.formatOptions(defaultOptions, userOptions);
    }
    _create_class._(ModuleFederation, [
        {
            key: "initOptions",
            value: function initOptions(userOptions) {
                if (userOptions.name && userOptions.name !== this.options.name) require_logger.error((0, _module_federation_error_codes.getShortErrorMsg)(_module_federation_error_codes.RUNTIME_010, _module_federation_error_codes.runtimeDescMap));
                this.registerPlugins(userOptions.plugins);
                var options = this.formatOptions(this.options, userOptions);
                this.options = options;
                return options;
            }
        },
        {
            key: "loadShare",
            value: function loadShare(pkgName, extraOptions) {
                return _async_to_generator._(function*() {
                    return this.sharedHandler.loadShare(pkgName, extraOptions);
                }).call(this);
            }
        },
        {
            key: "loadShareSync",
            value: function loadShareSync(pkgName, extraOptions) {
                return this.sharedHandler.loadShareSync(pkgName, extraOptions);
            }
        },
        {
            key: "initializeSharing",
            value: function initializeSharing() {
                var shareScopeName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : require_constant.DEFAULT_SCOPE, extraOptions = arguments.length > 1 ? arguments[1] : void 0;
                return this.sharedHandler.initializeSharing(shareScopeName, extraOptions);
            }
        },
        {
            key: "initRawContainer",
            value: function initRawContainer(name, url, container) {
                var remoteInfo = require_load.getRemoteInfo({
                    name,
                    entry: url
                });
                var module = new require_index$1.Module({
                    host: this,
                    remoteInfo
                });
                module.remoteEntryExports = container;
                this.moduleCache.set(name, module);
                return module;
            }
        },
        {
            key: "loadRemote",
            value: function loadRemote(id, options) {
                return _async_to_generator._(function*() {
                    return this.remoteHandler.loadRemote(id, options);
                }).call(this);
            }
        },
        {
            key: "preloadRemote",
            value: function preloadRemote(preloadOptions) {
                return _async_to_generator._(function*() {
                    return this.remoteHandler.preloadRemote(preloadOptions);
                }).call(this);
            }
        },
        {
            key: "initShareScopeMap",
            value: function initShareScopeMap(scopeName, shareScope) {
                var extraOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                this.sharedHandler.initShareScopeMap(scopeName, shareScope, extraOptions);
            }
        },
        {
            key: "formatOptions",
            value: function formatOptions(globalOptions, userOptions) {
                var _require_share_formatShareConfigs = require_share.formatShareConfigs(globalOptions, userOptions), shared = _require_share_formatShareConfigs.allShareInfos;
                var _this_hooks_lifecycle_beforeInit_emit = this.hooks.lifecycle.beforeInit.emit({
                    origin: this,
                    userOptions,
                    options: globalOptions,
                    shareInfo: shared
                }), userOptionsRes = _this_hooks_lifecycle_beforeInit_emit.userOptions, globalOptionsRes = _this_hooks_lifecycle_beforeInit_emit.options;
                var remotes = this.remoteHandler.formatAndRegisterRemote(globalOptionsRes, userOptionsRes);
                var allShareInfos = this.sharedHandler.registerShared(globalOptionsRes, userOptionsRes).allShareInfos;
                var plugins = _to_consumable_array._(globalOptionsRes.plugins);
                if (userOptionsRes.plugins) userOptionsRes.plugins.forEach((plugin)=>{
                    if (!plugins.includes(plugin)) plugins.push(plugin);
                });
                var optionsRes = _object_spread_props._(_object_spread._({}, globalOptions, userOptions), {
                    plugins,
                    remotes,
                    shared: allShareInfos
                });
                this.hooks.lifecycle.init.emit({
                    origin: this,
                    options: optionsRes
                });
                return optionsRes;
            }
        },
        {
            key: "registerPlugins",
            value: function registerPlugins(plugins) {
                var pluginRes = require_plugin.registerPlugins(plugins, this);
                this.options.plugins = this.options.plugins.reduce((res, plugin)=>{
                    if (!plugin) return res;
                    if (res && !res.find((item)=>item.name === plugin.name)) res.push(plugin);
                    return res;
                }, pluginRes || []);
            }
        },
        {
            key: "registerRemotes",
            value: function registerRemotes(remotes, options) {
                return this.remoteHandler.registerRemotes(remotes, options);
            }
        },
        {
            key: "registerShared",
            value: function registerShared(shared) {
                this.sharedHandler.registerShared(this.options, _object_spread_props._(_object_spread._({}, this.options), {
                    shared
                }));
            }
        }
    ]);
    return ModuleFederation;
}();
//#endregion
exports.ModuleFederation = ModuleFederation; //# sourceMappingURL=core.cjs.map
